class AccordionDetails extends HTMLElement {
  constructor() {
    super();

    this.accordions = this.querySelectorAll('accordion-blocks');

    this.accordions.forEach((accordion) => {
      accordion.addEventListener('click', this.controlAccordion.bind(this));
      accordion.addEventListener('keydown', (ev) => {
        if (ev.code === 'Enter' || ev.code === 'Space') {
          this.controlAccordion.bind(this)(ev);
        }
      });
    });
  }

  targetAccordion(target) {
    this.accordions.forEach((accordion) => {
      accordion.removeAttribute('open');
      accordion.classList.remove('open');
    });
    this.querySelectorAll('.accordion-content').forEach((accordionContent) => {
      accordionContent.style.height = '0';
    });

    target.closest('accordion-blocks').setAttribute('open', '');
    target.closest('accordion-blocks').classList.add('open');
  }

  controlAccordion(event) {
    let target = event.target;
    if (event.target.nodeName === 'H2') {
      target = event.target.parentNode;
    }
    const accordionBlockId = target.closest('accordion-blocks')?.getAttribute('id');
    if (accordionBlockId) {
      history.replaceState(null, '', '#' + accordionBlockId);

      const shouldScroll = this.dataset.scroll === 'true';
      if (shouldScroll) {
        setTimeout(() => {
          target.scrollIntoView({ behavior: 'smooth' });
        }, 300);
      }
    }
    if (target.hasAttribute('accordion-summary')) {
      target.closest('accordion-blocks').toggleAttribute('open');
      target.closest('accordion-blocks').classList.remove('open');

      if (target.closest('accordion-blocks').hasAttribute('open')) {
        this.targetAccordion(target);
        target.nextElementSibling.style.height = target.nextElementSibling.scrollHeight + 'px';
      } else {
        target.nextElementSibling.style.height = '0';
      }
    }
  }
}

customElements.define('accordion-details', AccordionDetails);
